import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHomeNavIconSecondary from './svgs/HomeNavIconSecondary.js';
import SvgHomeNavIcon from './svgs/HomeNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var homeNavIcon = (props => useIcon(SvgHomeNavIcon, SvgHomeNavIconSecondary, props));

export { homeNavIcon as default };
